import React, { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import { Card, CardContent, CardHeader, IconButton, List } from '@mui/material'
import { useParams } from 'react-router-dom'

import LoadingView from 'components/LoadingView'
import { useCampaignNotes, useDeleteCampaignNote } from 'hooks/useCampaignNotes'

import CampaignNote from './CampaignNote'
import CampaignNoteCreate from './CampaignNoteCreate'

const CampaignNotes = () => {
  const { id: campaignId } = useParams()
  const { data: notes, isLoading, error } = useCampaignNotes(campaignId)
  const deleteNote = useDeleteCampaignNote()
  const [open, setOpen] = useState(false)

  const handleDelete = (id: any, noteId: any) => deleteNote.mutate({ campaignId: id, noteId })

  const createButton = (
    <IconButton aria-label="Add note" onClick={() => setOpen(true)} size="large">
      <AddIcon />
    </IconButton>
  )

  return (
    <Card>
      <CardHeader action={createButton} title="Notes" />
      <CardContent>
        <LoadingView error={error ? 'Error occurred when loading notes data' : undefined} loading={isLoading}>
          <List>
            {(notes ?? []).map((note: any, index: any) => (
              <CampaignNote campaignId={campaignId ?? ''} deleteCampaignNote={handleDelete} key={index} note={note} />
            ))}
          </List>
        </LoadingView>
      </CardContent>
      <CampaignNoteCreate onClose={() => setOpen(false)} open={open} />
    </Card>
  )
}

export default CampaignNotes
